export default __webpack_public_path__ + "static/media/attention.9cdf9b68.png";